import React from 'react';
import PropTypes from 'prop-types';
import { EmojiIcon } from '../EmojiIcon';
import { calculateProfileScore, getArchetype } from '../../shared/profile-score-helpers';
import { getUserResponse } from '../../shared/answer-helpers';
import { SCORING_QUESTION_IDS, ARCHETYPES, CHAPTER_QUESTIONS } from '../../shared/story-archetypes';
import '../../assets/images/emoji-sprites/emoji-sprite-v56-result.css';
import styles from './ResultSlideV2.css';

function ResultSlideV2({ results }) {
    const archetype = getArchetype(calculateProfileScore(results.userResponses, SCORING_QUESTION_IDS), ARCHETYPES);
    const questions = CHAPTER_QUESTIONS.map(({ questionId, byAnswerId }) => byAnswerId[getUserResponse(results.userResponses, questionId)?.id]).filter(Boolean);

    return (
        <div className={styles.card}>
            <p className={styles.label}>Based on your answers, you are:</p>
            <div className={styles.titleSection}>
                <p className={styles.title}>{archetype.title} <EmojiIcon name={archetype.emoji} version='v56-result' className={styles.emoji} /></p>
                <p className={styles.description}>{archetype.description}</p>
            </div>
            <div className={styles.divider} />
            <p className={styles.questionsHeader}>Your first chapter starts here:</p>
            <ul className={styles.questionsList}>
                {questions.map((question, index) => (
                    <li key={question} className={styles.questionCard}>
                        <span className={styles.badge}>{String(index + 1).padStart(2, '0')}</span>
                        <p>{question}</p>
                    </li>
                ))}
            </ul>
        </div>
    );
}

ResultSlideV2.propTypes = {
    results: PropTypes.shape({ userResponses: PropTypes.array }).isRequired
};

export {
    ResultSlideV2
};
